import axios from "@axios";
import axiosDefault from "axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((server) => ({
        value: server.id,
        label: server.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axiosDefault.get(
        `${window.__env.VUE_APP_PBX_URL}/v1/devices`,
        { params }
      );

      if (!data.status) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async getCallerName({ dispatch }, device_id) {
      //TODO: Ver si no es necesario tambien mandar el domain
      const { data } = await axiosDefault.get(
        `${window.__env.VUE_APP_PBX_URL}/v1/devices?extension=${device_id}`
      );
      const deviceData = data.data[0];
      console.log("deviceData", { deviceData });

      if (deviceData.id_unit) {
        console.log("id_unit", deviceData.id_unit);
        let unitData = await dispatch("unit/get", deviceData.id_unit, { root: true });
        console.log("unitData", { unitData });
        if (unitData.data.description) return unitData.data.description;
        return device_id;
      }

      if (deviceData.id_user) {
        console.log("id_user", deviceData.id_user);
        let userData = await dispatch("user/getUserName", deviceData.id_user, {
          root: true,
        });
        if (userData.data.email) return userData.data.email;
        return device_id;
      }

      console.log("device_id_data");
      return device_id;
    },
    async add(_, params) {
      const { data } = await axiosDefault.post(
        `${window.__env.VUE_APP_PBX_URL}/v1/devices`,
        params
      );

      return data;
    },
    async export({ commit }, params) {
      const response = await axiosDefault.get(
        `${window.__env.VUE_APP_PBX_URL}/v1/devices`,
        {
          params: {
            ...params,
            export: true,
          },
          responseType: "blob",
          headers: {
            "Content-Disposition": "attachment; filename=template.xlsx",
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        }
      );

      if (!response.data) {
        return [];
      }

      let filename = "VoIP_devices.xlsx";

      console.log("paso")
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        filename
      );
      document.body.appendChild(link);
      link.click();
      link.remove();

      const notification = {
        id: filename,
        progress: 100,
        completed: true,
        view: "Devices VoIP",
        url: url,
        download: filename,
        title: "Reporte de dispositivos VoIP",
        body: "Descarga completa",
        error: false,
        timestamp:
          new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
      };
      store.dispatch("grid/updateDownloadNotification", notification);

      return response.data;
    },
    async edit(_, { id, params }) {
      const { data } = await axiosDefault.put(
        `${window.__env.VUE_APP_PBX_URL}/v1/devices/${id}`,
        params
      );

      return data;
    },
    async delete(_, id) {
      const { data } = await axiosDefault.delete(
        `${window.__env.VUE_APP_PBX_URL}/v1/devices/${id}`
      );

      return data;
    },

    clear({ commit }) {
      commit("setData", []);
    },
  },
};
